// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"8a424ab9","14":"7b5e9353","44":"bdae8399","223":"26a3b77a","378":"7026cd25","488":"0983cc55","997":"30bfa3ac"}[chunkId] + ".chunk.js";
};